"use client";
import Stepper from "../stepper/page";
import Homepage from "../componenets/Homep";

function page() {
  return (
    <div className="mb-10">
      <div>
        <Stepper countStep={0} />
      </div>
      <Homepage image={"master-page"} />
    </div>
  );
}

export default page;
